import { Component, Input, OnInit } from "@angular/core";
import { PopoverController } from "@ionic/angular";

@Component({
  selector: "app-activity-log-actions",
  templateUrl: "./activity-log-actions.component.html",
  styleUrls: ["./activity-log-actions.component.scss"]
})
export class ActivityLogActionsComponent implements OnInit {
  showAll: boolean = true;
  actionTypes: any = {
    // profileAccount: true,
    // upload: true,
    // application: true,
    // payment: true,

    user: true, //Trainee Activity Log
    application: true, //Application Activity Log
    department: true, //Institution Activity Log
    program: true, //Program Activity Log
    payment: true, //Payment activity log
    host: true, //Host Activity Log
  }
  adminUsers: any;
  activeItem: string;
  prefAdmin: any;
  adminProps: any;

  readOnly: boolean = false;
  @Input() action: any;
  @Input() open: string;
  @Input() adminList: any;


  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {
    console.log("received ", this.action);
    if(this.open == "logActions"){
      this.actionTypes = this.action;
      this.setShowAll();
    } else if(this.open == "adminActions"){
      //console.log(this.adminUsers);
      
      this.adminProps = this.adminList.map((b) => {
        return { optionText: b.name, optionValue: b.id };
      });

      this.adminUsers = JSON.stringify({
        id: "admins",
        optionItems: this.adminProps
      });

      this.prefAdmin= this.action;
      //console.log(this.prefAdmin,"received to modal");
      
    } else if(this.open == "dateActions"){
      this.activeItem = this.action;
    }
    
  }

  actionOpts(type:string) {
    if (type == "showAll") {
      if(this.showAll == true){
        Object.keys(this.actionTypes).map(e=> this.actionTypes[e]= true);
      }else{
        Object.keys(this.actionTypes).map(e=> this.actionTypes[e]= false);
      } 
    } else {
      this.setShowAll();
    }
    setTimeout(()=>this.popoverCtrl.dismiss(this.actionTypes),2000);
  }

  setShowAll(){
    this.showAll = Object.values(this.actionTypes).every(e => e == true); //on all true or not
  }

  dateAction(selection:string){
    this.activeItem = selection;
    setTimeout(()=>this.popoverCtrl.dismiss(selection),1500)
  }

  adminsEvent(ev: CustomEvent) {
   
    if (ev.detail.actionType === "selection") {
      this.prefAdmin = this.getArrayObj(ev.detail.value);
      //console.log(this.prefAdmin);
      setTimeout(()=>this.popoverCtrl.dismiss(this.prefAdmin),1500);
    } else if (ev.detail.actionType === "search") {
      const filterKey = ev.detail.value.toLowerCase();
      if (filterKey !== null && filterKey.length > 0) {

        const filteredList = [...this.adminProps]
          .filter((items) => {
            if (items.optionText.toLowerCase().indexOf(filterKey) > -1) {
              return items;
            }
          })
          .sort((a, b) => a.optionText.localeCompare(b.optionText));

        this.adminUsers = JSON.stringify({
          id: "admins",
          optionItems: filteredList
        });
      }
    } else if (ev.detail.actionType === "reset") {
      this.adminUsers = JSON.stringify({
        id: "admins",
        optionItems: this.adminProps
      });
    }
  }

  adminsMenuClosed(ev: CustomEvent) {
    // if (ev.detail && ev.detail.click) {
    //   // const admins = this.adminList.map((b) => {
    //   //   return { optionText: b.name, optionValue: b.id };
    //   // });

    //   this.adminUsers = JSON.stringify({
    //     id: "admins",
    //     optionItems: this.adminProps
    //   });
    // }
  }

  getArrayObj(obj) {
    if (Array.isArray(obj)) {
      return obj;
    } else {
      if (typeof obj == "string" && obj.length > 0) {
        try {
          return JSON.parse(obj).map((item) => item.text);
        } catch (e) {
          //bad json format
          return obj;
        }
      } else {
        return obj;
      }
    }
  }


}
